import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse2Fill = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m16.163,5.273l-5.081-3.266c-.657-.423-1.507-.423-2.163,0l-5.082,3.267h0c-1.15.74-1.837,1.998-1.837,3.365v5.362c0,2.206,1.794,4,4,4h3v-4c0-.552.448-1,1-1s1,.448,1,1v4h3c2.206,0,4-1.794,4-4v-5.362c0-1.367-.687-2.625-1.837-3.365Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconHouse2Fill.js.map